import { KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';

export function initializer(keycloak: KeycloakService): () => Promise<any> {
  return (): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        await keycloak.init({
          config: {
            url: environment.ssoUrl,
            realm: 'SDS',
            clientId: 'wind-log-fe'
          },
          initOptions: {
            onLoad: 'login-required',
            checkLoginIframe: false
          },
          bearerExcludedUrls: [environment.ssoUrl]
        });
        resolve(true);
      } catch (error) {
        reject(error);
      }
    });
  };
}
